/* src/app/components/payroll/claim-adjustment/adjust-service-claim/adjust-service-claim.component.css */
.form-sec {
  border: 3px solid white;
  border-radius: 4px;
  margin: 24px 12px;
}
.ppl-container-head {
  color: #00504B;
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
}
.form-container {
  border: 2px solid white;
  border-radius: 8px;
  margin: 8px;
}
/*# sourceMappingURL=adjust-service-claim.component-BWKLHPXG.css.map */
